module.exports = __webpack_public_path__ + "static/media/rest-plates.1275ef21.png";